/**
 * Le due sezioni principali, e tutto il resto.
 *
 * Otto non è un gestionale: è una conversazione con qualcuno che guarda il
 * gestionale al posto tuo. Quindi in piedi restano due cose sole — **quello
 * che gli chiedi** (Chat) e **quello che ti dice lui** (Avvisi) — e tutto il
 * resto vive dietro una scorciatoia, a portata di un tap sopra la chat.
 *
 * È una scelta di prodotto, non di layout: ogni voce di menu in più è un invito
 * a usare Otto come un pannello di controllo, che è esattamente il prodotto che
 * non stiamo facendo.
 */

import {
  Bell,
  Building2,
  History as HistoryIcon,
  Inbox as InboxIcon,
  MessageSquare,
  Settings as SettingsIcon,
  Sparkles,
  Sun,
} from "lucide-react";

export type View = "chat" | "alerts" | "settings";

/** Le schermate che si aprono sopra la chat, senza lasciarla. */
export type Scorciatoia =
  "today" | "inbox" | "listings" | "suggestions" | "history";

export interface NavItem {
  id: View;
  label: string;
  Icon: typeof MessageSquare;
  descrizione: string;
}

export const SEZIONI: NavItem[] = [
  {
    id: "chat",
    label: "Chat",
    Icon: MessageSquare,
    descrizione: "Scrivi cosa vuoi cambiare",
  },
  {
    id: "alerts",
    label: "Avvisi",
    Icon: Bell,
    descrizione: "Quello che ho notato da solo",
  },
  {
    id: "settings",
    label: "Impostazioni",
    Icon: SettingsIcon,
    descrizione: "Limiti, autonomia, collegamento",
  },
];

export interface ScorciatoiaItem {
  id: Scorciatoia;
  label: string;
  Icon: typeof MessageSquare;
  /** La riga che spiega cosa fa: compare nella legenda e nel titolo della finestra. */
  descrizione: string;
  /** Le schermate a due colonne vanno a tutta finestra, senza margini interni. */
  pieno?: boolean;
}

export const SCORCIATOIE: ScorciatoiaItem[] = [
  {
    id: "today",
    label: "Oggi",
    Icon: Sun,
    descrizione: "Chi arriva, chi parte, chi pulisce",
  },
  {
    id: "inbox",
    label: "Messaggi",
    Icon: InboxIcon,
    descrizione: "Le conversazioni con gli ospiti",
    pieno: true,
  },
  {
    id: "listings",
    label: "Immobili",
    Icon: Building2,
    descrizione: "Calendario e prezzi, casa per casa",
    pieno: true,
  },
  {
    id: "suggestions",
    label: "Consigli",
    Icon: Sparkles,
    descrizione: "Cosa manca nei tuoi annunci",
  },
  {
    id: "history",
    label: "Storico",
    Icon: HistoryIcon,
    descrizione: "Tutto quello che ho fatto",
  },
];

export function scorciatoia(id: Scorciatoia): ScorciatoiaItem {
  return SCORCIATOIE.find((s) => s.id === id) ?? SCORCIATOIE[0]!;
}
